module.exports = __WEBPACK_EXTERNAL_MODULE__39938__;